import { AttributeCode } from './attributeCode';
import { Schema } from 'effect';

export const TextFilterValue = Schema.HashSet(Schema.String);

export type TextFilterValue = Schema.Schema.Type<typeof TextFilterValue>;

// Simplified structure: direct mapping from AttributeCode to TextFilterValue
export const TextFilterStateMap = Schema.HashMap(AttributeCode, TextFilterValue);

export type TextFilterStateMap = Schema.Schema.Type<typeof TextFilterStateMap>;
